import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { OrganizationUnitService } from 'app/support/organizationUnits/organizationUnit.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-organisation-units-search-action',
  templateUrl: './organisation-units-search-action.component.html',
  styleUrls: ['./organisation-units-search-action.component.scss']
})
export class OrganisationUnitsSearchActionComponent extends DialogContentBase implements OnInit, OnDestroy {
 public dataSource = []
 private _subject$: Subject<boolean> = new Subject();
 selectOrganisationUnit = null;
 organisationUnit :string;
 public index = null;
  constructor(dialog: DialogRef,
    private organizationUnitService: OrganizationUnitService)
     { super(dialog);}

  ngOnInit() {
    this.getOrganizationUnits();
  }
  getOrganizationUnits(): void { 
    this.organizationUnitService
      .getAll()
      .pipe(takeUntil(this._subject$))
      .subscribe((data) => {
        this.dataSource = data;
      });
  }
  closeDialog() { 
    if(this.selectOrganisationUnit != null)
    this.save(this.selectOrganisationUnit);
    this.selectOrganisationUnit = null; 
  }
  onCellClick($event) {
    this.selectOrganisationUnit = $event.dataItem
  }
  
  public cancel(): void {
    this.dialog.close();
  }
public save(item): void{
this.organisationUnit = item;
this.dialog.close(item);

}
  ngOnDestroy(): void {
    this._subject$.unsubscribe();
  }
}
